export const PASSKEY_REGISTER_EXPERIMENT = 'passkeys_register';

// The live Statsig config ID is plural. The independently managed Descope
// decision-screen label remains singular.
export const PASSKEY_REGISTER_POST_LOGIN_EXPERIMENT =
  'passkeys_register_post_login';

export type PasskeyRegistrationRumExperiment =
  | typeof PASSKEY_REGISTER_EXPERIMENT
  | typeof PASSKEY_REGISTER_POST_LOGIN_EXPERIMENT;
